<!--
 * @Description: 学生测试记录
 * @Author: PF
 * @Date: 2025-10-29 09:41:22
 * @LastEditors: PF
 * @LastEditTime: 2025-11-27 10:52:38
-->
<template>
  <div class="list-page">
    <el-container>
      <el-header>
        <!-- 搜索区域 BEGIN -->
        <el-form class="search-box" :model="dataGrid.parms" @submit.enter.prevent>
          <el-form-item>
            <el-select placeholder="学期" v-model="dataGrid.parms.xqid" clearable filterable @change="bindTable()">
              <el-option v-for="item in xqData" :key="item.id" :label="item.xqmc" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select placeholder="系部" v-model="dataGrid.parms.xbid" clearable filterable :teleported="false" @change="initZhuanYe();bindTable()">
              <el-option v-for="item in xbData" :key="item.id" :label="item.jgmc" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select placeholder="专业" v-model="dataGrid.parms.zyid" clearable filterable :teleported="false" @change="initBanJi();bindTable()">
              <el-option v-for="item in zyData" :key="item.id" :label="item.zymc" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select placeholder="年级" v-model="dataGrid.parms.njid" clearable filterable :teleported="false" @change="initBanJi();bindTable()">
              <el-option v-for="item in njData" :key="item.id" :label="item.njmc" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select placeholder="班级" v-model="dataGrid.parms.bjid" clearable filterable :teleported="false" @change="bindTable()">
              <el-option v-for="item in bjData" :key="item.id" :label="item.xzbmc" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input placeholder="学生" v-model="dataGrid.parms.xm" clearable @clear="bindTable()" @keyup.enter="bindTable()">
              <template #suffix>
                <el-icon class="el-input__icon pointer" @click="bindTable()">
                  <search />
                </el-icon>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-input placeholder="网络课程" v-model="dataGrid.parms.wlkcmc" clearable @clear="bindTable()" @keyup.enter="bindTable()">
              <template #suffix>
                <el-icon class="el-input__icon pointer" @click="bindTable()">
                  <search />
                </el-icon>
              </template>
            </el-input>
          </el-form-item>
        </el-form>
      </el-header>
      <el-main>
        <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
          <el-table-column type="index" label="序号" align="center" width="80" />
          <el-table-column label="学号" prop="xh" min-width="100" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
          <el-table-column label="学生" prop="xm" min-width="100" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
          <el-table-column label="年级" prop="njmc" width="100" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
          <el-table-column label="班级" prop="bjmc" min-width="160" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
          <el-table-column label="课程" prop="kcmc" min-width="150" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
          <el-table-column label="网络课程" prop="wlkcmc" min-width="180" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
          <el-table-column label="试卷" prop="sjmc" min-width="150" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
          <el-table-column label="最终成绩" prop="zzcj" width="105" align="center" sortable :sort-orders="['ascending', 'descending']" />
          <el-table-column label="操作" width="100" fixed="right" align="center">
            <template #default="scope">
              <el-button type="primary" link @click="id=scope.row.id;xsid=scope.row.xsid;initJieGuo()">查看结果</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <!-- 分页 -->
      <el-footer>
        <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
      </el-footer>
    </el-container>
  </div>
  <el-dialog title="考试结果" v-model="openChaKan" class="w550 h600" :close-on-click-modal="false" @close="openChaKan=false">
    <el-container>
      <el-main class="pb20 pt0 pl0 pr0">
        <el-table :data="ksjgData" style="width: 100%" height="100%" @row-click="rowClick">
          <el-table-column prop="kssj" label="开始时间" width="180" align="center" />
          <el-table-column prop="tjsj" label="交卷时间" width="180" align="center" />
          <el-table-column prop="fs" label="得分" align="center" />
        </el-table>
      </el-main>
      <el-footer>
        <pagination :pagination="pagiKsjgObj" @ReturnData="initJieGuo" style="justify-content: flex-end;" />
      </el-footer>
    </el-container>
  </el-dialog>
  <detail v-if="openKaoShiDetail" v-model:visible="openKaoShiDetail" :row="tcrow" />
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { loadList, submitDataGridAction, homeCloseWindow, loadSelect, actionPost } from '@/api/common.js'
import pagination from '@/components/pagination.vue'
import shiJuan from '@/components/shiJuanDetail'
import detail from './detail.vue'

const props = defineProps({ row: { type: Object, required: false } })

const countNotBegin = ref(0)
const countBegin = ref(0)
const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {
    pagerCount: 5,
    layout: 'prev, pager, next, total'
  },
  loading: false,
  orderBy: { prop: 'xh', order: 'ascending' },
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const bindTable = async (pageNo, pageSize) => {
  dataGrid.value.parms.isAll = 0
  dataGrid.value.parms.sjlx = 1 // 试卷类型:1-考试 2-测试
  loadList({
    url: '/api/v2/wangluojiaoxue/chengji/kaoshijilu',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    pagerCount: 5,
    layout: 'prev, pager, next, total',
    dataGrid: dataGrid.value,
    loadSuccess: function (res) {
      dataGrid.value.multipleSelection = []
      countNotBegin.value =  res.data ? res.data.countNotBegin : 0 //未学习的人数
      countBegin.value =  res.data ? res.data.countBegin : 0 //已开始学习人数
    }
  })
}

// 加载 学期 下拉框
const xqData = ref()
const initXueQi = () => {
  loadSelect({
    url: '/api/v2/pdp/xueqi/list',
    data: xqData,
    order: 'sx',
    sort: 'asc',
    loadSuccess: function (res) {
      res.data.forEach((element) => {
        if (element.sfdqxq === true) {
          dataGrid.value.parms.xqid = element.id
          bindTable()
        }
      })
    }
  })
}
  
// 加载 系部 下拉框
const xbData = ref()
loadSelect({ url: '/api/v2/xiaoneijigou/listxibu', data: xbData, order: 'jgh', sort: 'asc' })

// 加载 年级 下拉框
const njData = ref()
loadSelect({ url: '/api/v2/pdp/nianji/list', data: njData, order: 'njdm', sort: 'asc' })

// 加载 专业 下拉框
const zyData = ref()
const initZhuanYe = () => {
  loadSelect({
    url: '/api/v2/pdp/zhuanye/list',
    data: zyData,
    parms: {
      xbid: dataGrid.value.parms.xbid,
      ccid: dataGrid.value.parms.ccid
    },
    order: 'zybh',
    sort: 'asc'
  })
}
initZhuanYe()

// 加载 班级 下拉框
const bjData = ref()
const initBanJi = () => {
  loadSelect({
    url: '/api/v2/pdp/banji/list',
    data: bjData,
    parms: {
      zyid: dataGrid.value.parms.zyid,
      njid: dataGrid.value.parms.njid
    },
    order: 'xzbdm',
    sort: 'asc'
  })
}
initBanJi()

// 弹窗
const tcrow = ref({})

// Excel导出
const exportData = async () => {
  exportExcel(
    '/api/v2/xuesheng/banzhurengongzuogebiejiaoyujilu/export',
    dataGrid.value
  )
}

watch(
  () => props.row,
  () => {
    if (props.row) {
      dataGrid.value.parms.lsid = props.row.lsid
    }
    initXueQi()
  },
  { deep: true, immediate: true }
)

// 考试结果
const openChaKan = ref(false)
const openKaoShiDetail = ref(false)
const ksjgData = ref([])
const pagiKsjgObj = ref({})
const id = ref('')
const xsid = ref('')
const initJieGuo = (pageNo, pageSize) => {
  actionPost({
    url: `/api/v2/wangluojiaoxue/xuesheng/kaoshi/jilu`,
    data: {
      kssjid: id.value,
      xsid: xsid.value,
      pageNo: pageNo || 1,
      pageSize: pageSize || 100
    }
  }).then((res) => {
    if (res.code === 200) {
      openChaKan.value = true
      ksjgData.value = res.data.list || []
      pagiKsjgObj.value = {
        pageNo: pageNo || 1,
        pageSize: pageSize || 100,
        pagerCount: 5,
        layout: 'prev, pager, next, total',
        total: res.data.total
      }
    } else {
      warningPrompt(res.message)
    }
  })
}
const rowClick = (val) => {
  tcrow.value = val
  openKaoShiDetail.value = true
}
</script>
